import { UserID } from '../../../../../../users/usersTypes';
import { UpdateOperationFormAccess } from '../../UpdateOperationForm.types';

import { useCurrentUser } from '../../../../../../../auth/hooks/useAuth';

import { UsersPermissions } from '../../../../../../users/usersConstants';

interface UpdateOperationFormCheckUserAccessOptions {
  userId: UserID;
}

function useUpdateOperationFormCheckUserAccess({
  userId
}: UpdateOperationFormCheckUserAccessOptions): UpdateOperationFormAccess {
  const currentUser = useCurrentUser();
  const isSelf = userId === currentUser.id;

  const changeClientId = false;
  const changeOperationType = currentUser.hasPermissions(
    isSelf
      ? UsersPermissions.CHANGE_SELF_RECORD_OPERATION_TYPE
      : UsersPermissions.CHANGE_USER_RECORD_OPERATION_TYPE
  );
  const changeSubject = currentUser.hasPermissions(
    isSelf
      ? UsersPermissions.CHANGE_SELF_RECORD_SUBJECT
      : UsersPermissions.CHANGE_USER_RECORD_SUBJECT
  );
  const changeBody = currentUser.hasPermissions(
    isSelf
      ? UsersPermissions.CHANGE_SELF_RECORD_BODY
      : UsersPermissions.CHANGE_USER_RECORD_BODY
  );
  const changeDate = currentUser.hasPermissions(
    isSelf
      ? UsersPermissions.CHANGE_SELF_RECORD_DATE
      : UsersPermissions.CHANGE_USER_RECORD_DATE
  );
  const changeCompleteDatetime = currentUser.hasPermissions(
    isSelf
      ? UsersPermissions.CHANGE_SELF_RECORD_COMPLETE_DATETIME
      : UsersPermissions.CHANGE_USER_RECORD_COMPLETE_DATETIME
  );
  const changeState = currentUser.hasPermissions(
    isSelf
      ? UsersPermissions.CHANGE_SELF_RECORD_STATE
      : UsersPermissions.CHANGE_USER_RECORD_STATE
  );
  const changeFileAttachmentIds = currentUser.hasPermissions(
    isSelf
      ? UsersPermissions.CHANGE_SELF_RECORD_FILE_ATTACHMENT_IDS
      : UsersPermissions.CHANGE_USER_RECORD_FILE_ATTACHMENT_IDS
  );

  return {
    changeClientId,
    changeOperationType,
    changeSubject,
    changeBody,
    changeDate,
    changeCompleteDatetime,
    changeState,
    changeFileAttachmentIds
  };
}

export default useUpdateOperationFormCheckUserAccess;
